import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { XPRESS_LOAN, XPRESS_ACCOUNT_TYPES_APPROVEDACCOUNT_TYPE, XPRESS_FUNDING_SOURCESFUNDING_SOURCE, XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type, XPRESS_ACCOUNT_TYPESACCOUNT_TYPE, XPRESS_LOANINTERESTED_ACCOUNTS, XPRESS_LOAN_INFOStatus, XPRESS_FUNDING_SOURCESFUNDING_SOURCEBank_account_type } from 'src/models/xpress_loan.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CreditCardFormComponent } from './../credit-card-form/credit-card-form.component';
import { FUNDDEPOSIT_INPUTREQUEST, INPUTREQUESTCARD_DETAILS } from 'src/models/fund-deposit.model';
import { ApiService } from 'src/shared/api.service';
import { CardDetails } from './../credit-card-form/card-details';
import * as _ from 'lodash';
import { BankFormComponent } from './../bank-form/bank-form.component';
import { ApplicantService } from 'src/shared/applicant.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { LoanAppService } from 'src/shared/loan-app.service';
import { CREDITCARD_LOAN11 } from 'src/models/creditcard_loan.model';
import { VEHICLE_LOAN } from 'src/models/vehicle_loan.model';
import { PERSONAL_LOAN } from 'src/models/personal_loan.model';
import { HE_LOAN } from 'src/models/he_loan.model';
import { APP_STATUSValue, FinalPageEnum } from 'src/models/common.model';
import { AppComponent } from 'src/app/app.component';
import { MemberService } from 'src/shared/member.service';
import { ApplicantLoanComponent } from 'src/app/applicant-loan/applicant-loan.component';
import { ActivatedRoute, Route } from '@angular/router';
import { NmaoWfService } from 'src/shared/nmao-wf.service';
import { FinalPageComponent } from 'src/components/final-page/final-page.component';
import { LoanApiLogService } from 'src/shared/loan-api-log.service';
import { PlaidService } from 'src/shared/plaid.service';
import { ConfirmationDialog } from 'src/components/confirmation-dialog/confirmation-dialog.component';

declare var gtag: any;

@Component({
  selector: 'app-branch-funding-page',
  templateUrl: './branch-funding-page.component.html',
  styleUrls: ['./branch-funding-page.component.css']
})
export class BranchFundingPageComponent implements OnInit {

  selectedFundingType: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type;
  fundingModel: any={}
  
  @Input() creditCardLoan: CREDITCARD_LOAN11;

  @Input() vehicleLoan: VEHICLE_LOAN;

  @Input() personalLoan: PERSONAL_LOAN;

  @Input() heLoan: HE_LOAN;

  @Input() xpressLoan:XPRESS_LOAN ={} as any;

  @Input() selectedProducts: any[];
  @Input() submitHistory: any;

  AppComponent = AppComponent;
  
  captchaRequired: boolean = false;
  reactiveForm: FormGroup;
  captchaToken: string;
  ApplicantLoanComponent = ApplicantLoanComponent;

  soResponses: any = {
    xpress: {},
    //decision: {}
  };

  selectedFundingSource: any;
  interestedAccounts : XPRESS_ACCOUNT_TYPESACCOUNT_TYPE[] = [];

  cardDetails:CardDetails;
  bankDetails: any = {};
  isSelectedMethod = false;

  isCash: boolean = false;
  isLoading = false;
  branchFundingForm = new FormGroup({}) 

  public fundingSources:  any = [];

  invalidRoutingNumnerMsg ="";
  helperTextFundingPage : any;

  public totalDeposit  =0;
  public savingsTotalDeposit = 0;
  public certificateTotalDeposit = 0;
  isValidForm = true;
  isCallBack = false;
  messageErrors = [] as any[];

  showPlaidError = false;

  constructor(private fb: FormBuilder, private dialog: MatDialog, private apiService: ApiService,
    private loanAppService: LoanAppService,
    private memberService: MemberService,
    private applicantService: ApplicantService,
    private route: ActivatedRoute,
    private nmaoWfService: NmaoWfService,
    private loanApiLogService: LoanApiLogService,
    private plaidService: PlaidService
    ) { }

  ngOnInit(): void {
    var param = this.route.snapshot.queryParams;
    const productWithType2 = _.find(this.selectedProducts, { applicationType: 2 });
    var at = productWithType2 ? 2 : 1;
    this.getFundingSources(at, "ref="+ param.ref);
    this.getHelperTextFromConfig();
    this.reactiveForm = new FormGroup({
      recaptchaReactive: new FormControl(null, Validators.required)
    });
    this.selectedProducts = _.orderBy(this.selectedProducts,  ['productGroupId', 'id'], ['asc', 'asc']);
    this.interestedAccounts = this.applicantService.initInterestedAccounts(this.selectedProducts);
     console.log(this.selectedProducts)
     console.log(this.interestedAccounts)
    this.branchFundingForm = this.fb.group({

    })

    _.each(this.interestedAccounts, acc=>{
      this.branchFundingForm.addControl(acc.account_name, new FormControl('',[Validators.required, Validators.min(acc.min_deposit)]))
    })

    this.memberService.checkMemberSubmit().subscribe(r => {
      if (r) {
        this.captchaRequired = true;
      }
    });

    // (window as any).dataLayer.push({
    //   event: 'go-To-Funding-Page',
    //   value:  'User go to funding page'
    // });
  }



  async ngAfterViewInit() {
    var fundingLog = {
      submitHistoryId: this.submitHistory.id,
      appEvent: "Go to funding page",
      appId: this.submitHistory.XAId.toString()
    }
    try {
      this.apiService.saveFundingLog(fundingLog).subscribe(r => { })
    } catch { }

    try{
      this.memberService.postUserSession({
        lastPage: ApplicantLoanComponent.currentStepId,
        appId: this.submitHistory?.XAId,
        lastPageMetaData: null,
        productsJson: JSON.stringify(this.selectedProducts),
        sessionId:  ApplicantLoanComponent.sessionId,
        fullName: !!!this.xpressLoan.APPLICANTS? '' : this.xpressLoan?.APPLICANTS[0]?.first_name  + " " + this.xpressLoan?.APPLICANTS[0]?.last_name
      }).subscribe(r=>{});
    }catch{}
  }

  getCertProdsOnly(isOther = false) {
    const result = this.interestedAccounts.filter(account =>
      this.selectedProducts.some(product =>
        isOther
          ? product.productGroupId !== 3 && product.productCode === account.product_code
          : product.productGroupId === 3 && product.productCode === account.product_code
      )
    );
    return result;
  }

  checkFormValid(){
    this.messageErrors = [];
      Object.keys(this.branchFundingForm.controls).forEach(controlName => {
        const control = this.branchFundingForm.get(controlName);
        if (control && control.errors) {
          if (control.errors['required']) {
            this.messageErrors.push(`${controlName} is required.`);
          }
          if (control.errors['min']) {
            this.messageErrors.push(
              `${controlName} must be at least $${control.errors['min'].min}.`
            );
          }
          if (control.errors['max']) {
            this.messageErrors.push(
              `${controlName} must be less than or equal to $${control.errors['max'].max}.`
            );
          }
          this.isValidForm = false;
        }
      });

      // Check savings products maximum limit
      if(this.savingsTotalDeposit > 12000) {
        this.messageErrors.push('Maximum combined deposit for savings products cannot exceed $12,000.');
        this.isValidForm = false;
      }

      // Check certificate products maximum limit
      if(this.certificateTotalDeposit > 250000) {
        this.messageErrors.push('Maximum combined deposit for certificate products cannot exceed $250,000.');
        this.isValidForm = false;
      }

      if((!this.xpressLoan.FUNDING_SOURCES || this.xpressLoan.FUNDING_SOURCES.length ==0 || !this.selectedFundingSource) && !this.isCash){
        this.messageErrors.push('Please select funding method.');
        this.isValidForm = false;
      }
      if(this.selectedFundingSource && this.selectedFundingSource.funding_Type == XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK && !this.bankDetails.bank_account_number){
        this.messageErrors.push('Please add a bank account');
        this.isValidForm = false;
      }
      if(this.selectedFundingSource && this.selectedFundingSource.funding_Type == XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CREDITCARD && !this.cardDetails.cardHolder){
        this.messageErrors.push('Please add a credit card');
        this.isValidForm = false;
      }
      if(this.selectedFundingSource && this.selectedFundingSource.maxDeposit <  this.totalDeposit){
      this.messageErrors.push(`Total deposit should not be greater than $${this.selectedFundingSource.maxDeposit}`)
        this.isValidForm = false;
        this.isCallBack = true;
      }
  }

  selectFundingMethod(fundingSource, index, event){
    if(this.isSelectedMethod){
      return;
    }

    switch(fundingSource.funding_Type){
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK:      
        if (fundingSource.displayName && fundingSource.displayName.toLowerCase().includes('plaid')) {
          try{
            this.saveMiscEvent('FundingSourceFormAction', 'Opened plaid form.');
          }catch{}
          this.openPlaidForm(index, fundingSource);
        } else {
          try{
            this.saveMiscEvent('FundingSourceFormAction', 'Opened bank form.');
          }catch{}
          this.openBankForm(index, fundingSource);
        }   
        break;
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CREDITCARD:
        try{
          this.saveMiscEvent('FundingSourceFormAction', 'Opened credit card form.');
        }catch{}
        this.openCreditCardForm(index, fundingSource);
        break;
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CASH:
        this.setCashFundingSource();
        break; 
      default:
        break; 
    }
  }

  setActiveFundingSource(index){
    _.each(this.fundingSources, (funding, i) =>{
      if(i == index){
        funding.isSelected = true;
      }else{
        funding.isSelected = false;
      }
   })
  }


  openCreditCardForm(index, fundingSource, existingCard?){   
    if(!existingCard){
      existingCard=new  CardDetails("","",undefined,"","");
      existingCard.billing_ADDRESS_is_current = true
      try{
        existingCard.billing_street_address= this.xpressLoan.APPLICANTS[0].CURRENT_ADDRESS.LOOSE_ADDRESS.street_address_1,
        existingCard.billing_zip= this.xpressLoan.APPLICANTS[0].CURRENT_ADDRESS.LOOSE_ADDRESS.zip,
        existingCard.billing_city= this.xpressLoan.APPLICANTS[0].CURRENT_ADDRESS.LOOSE_ADDRESS.city,
        existingCard.billing_state=  this.xpressLoan.APPLICANTS[0].CURRENT_ADDRESS.LOOSE_ADDRESS.state   
      }catch{
      }

    }
    this.dialog.open(CreditCardFormComponent, {
      panelClass: AppComponent.isDesktop ? 'col-md-6' : 'full-screen',
      scrollStrategy:  AppComponent.scrollStrategy,
      data:{
        existingCard: existingCard,
        submitHistory: this.submitHistory
      }
    }).afterClosed().subscribe(r=>{
      try{
        this.saveMiscEvent('FundingSourceFormAction', 'Closed credit card form.');
      }catch{}
      if (r) {
        this.setActiveFundingSource(index)
        this.selectedFundingType = XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CREDITCARD;
        this.isCash = false;
        this.bankDetails = {} as any;
        this.cardDetails = {...r};
        if(! this.xpressLoan.FUNDING_SOURCES){
          this.xpressLoan.FUNDING_SOURCES = [];
        }
        var fundingCreditCard =  _.find(this.fundingSources, {funding_Type: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CREDITCARD})
        var fundingSourceCreditCard = {
          clf_funding_source_id: fundingCreditCard.clF_Funding_Source_Id,
          funding_type: fundingCreditCard.funding_Type,
          cc_card_type: "Visa",
          name_on_card: this.cardDetails.cardHolder,
          cc_card_number: this.cardDetails.cardNumber,
          cc_card_last4: this.cardDetails.cardNumber.slice(-4),
          cc_card_exp_date: new Date(`${this.cardDetails.expirationYear}-${this.cardDetails.expirationMonth}-01`),
          cc_charge_failure_count: 0,
        } as any;
        fundingSourceCreditCard = {...existingCard,...this.cardDetails,...fundingSourceCreditCard}
        this.xpressLoan.FUNDING_SOURCES.push(fundingSourceCreditCard);
        this.isSelectedMethod = true;
        this.selectedFundingSource = fundingSource;
        var fundingLog = {
          appId : this.submitHistory.XAId,
          submitHistoryId : this.submitHistory.id,
          appEvent : "Submitted credit card",
          fundingType:   this.selectedFundingType,
          cc_Card_Last4 :this.cardDetails.cardNumber.slice(-4),
          cc_Card_Cvn : this.cardDetails.ccv,
          cardHolderName: this.cardDetails.cardHolder.split(' ')
          .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
          .join(' ')
        } as any;
        try{
          this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}  
        try{
          this.saveMiscEvent('FundingSourceAdd-Remove', 'Added credit card.');
        }catch{}

      }else{
        var fundingLog = {
          appId : this.submitHistory.XAId,
          submitHistoryId : this.submitHistory.id,
          appEvent : "Closed credit card",
        } as any;
        try{        
          this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}
      }
      this.checkFormValid();

    })
  }
  
  openBankForm(index,fundingSource, existingBank?){
    this.dialog.open(BankFormComponent, {
      panelClass: AppComponent.isDesktop ? 'col-md-4' : 'full-screen',
      scrollStrategy:  AppComponent.scrollStrategy,
      data:{
        existingBank: existingBank,
        submitHistory: this.submitHistory,
      },
      autoFocus: true,
      disableClose: true
    }).afterClosed().subscribe(r=>{
     try{
      this.saveMiscEvent('FundingSourceFormAction', 'Closed bank form.');
     }catch{}
      if (r) {
        this.setActiveFundingSource(index);
        this.selectedFundingType = XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK;
        this.isCash = false;
        this.cardDetails = {} as any;
        this.bankDetails = {...r}
 
        var fundingBank =  _.find(this.fundingSources, {funding_Type: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK})

        var fundingLog = {
          appId : this.submitHistory.XAId,
          submitHistoryId : this.submitHistory.id,
          appEvent :"Submitted bank account",
          fundingType:   this.selectedFundingType,
          accountHolderName : this.bankDetails.bank_name_on_card.split(' ')
          .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
          .join(' '),
          routingNumber : this.bankDetails.routing_number,
          accountNumber:  this.bankDetails.bank_account_number
          .slice(-4)
          .padStart(this.bankDetails.bank_account_number.length, '*'),
          bankAccountType : this.bankDetails.bank_account_type
        } as any;
        try{
          this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}

        if(! this.xpressLoan.FUNDING_SOURCES){
          this.xpressLoan.FUNDING_SOURCES = [];
        }

        r.clf_funding_source_id = fundingBank?.clF_Funding_Source_Id,
        r.funding_type = fundingBank?.funding_Type


        this.xpressLoan.FUNDING_SOURCES.push(r);
        this.isSelectedMethod = true;
       this.selectedFundingSource = fundingSource;

       try{
        this.saveMiscEvent('FundingSourceAdd-Remove', 'Added bank.');
      }catch{}
      this.showPlaidError = false;
      }else{
        var fundingLog = {
          appId : this.submitHistory.XAId,
          submitHistoryId : this.submitHistory.id,
          appEvent : "Closed bank",
        } as any;
        try{
          this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}
      }
      this.checkFormValid();
    })
  }

  setCashFundingSource(){
    this.xpressLoan.FUNDING_SOURCES = [
      _.find(this.fundingSources, {funding_Type: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CASH})
    ];
    this.selectedFundingType = XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CASH;
    this.isCash = true;
    this.isSelectedMethod = true;
    this.checkFormValid();
  }


  async submitXA(){
    this.isValidForm = true;
    this.isCallBack =true;
     await this.checkFormValid();

    if(!this.isValidForm || this.messageErrors.length>0){
      return;
    }

    this.isLoading = true;



    var resReflectAlloyCompleteOutcome = await this.nmaoWfService.getAndReflectAlloyFinalStatus(this.submitHistory.id);
    if (resReflectAlloyCompleteOutcome?.toLowerCase() === "denied") {
      await this.processDeinedCase(this.submitHistory.id, this.submitHistory.XAId, this.submitHistory.decisionAppId);
    } else if (resReflectAlloyCompleteOutcome?.toLowerCase() === "approved") {
      await this.proccessApprovedCase(this.submitHistory.id, this.submitHistory.XAId, this.submitHistory.decisionAppId);
    } else {
      await this.proccessWaitingReviewCase(this.submitHistory.id, this.submitHistory.XAId, this.submitHistory.decisionAppId);
    }
  }

  saveSubmitFundingLog(response){
      try{
        var fundingLog = {
          appId: this.submitHistory?.XAId,
          submitHistoryId: this.submitHistory?.id,
          appEvent: "Submitted funding page",
          fundingType: this.selectedFundingType,
          accountHolderName: this.bankDetails?.bank_name_on_card?.split(' ')
              .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
              .join(' '),
          routingNumber: this.bankDetails?.routing_number,
          accountNumber: this.bankDetails?.bank_account_number
              ?.slice(-4)
              ?.padStart(this.bankDetails?.bank_account_number.length, '*'),
          bankAccountType: this.bankDetails?.bank_account_type,
          cc_Card_Last4: this.cardDetails?.cardNumber?.slice(-4),
          cc_Card_Cvn: this.cardDetails?.ccv,
          cardHolderName: this.cardDetails?.cardHolder?.split(' ')
              .map((word, index) => index === 0 ? word : word.replace(/./g, '*'))
              .join(' '),
          responseEvent: JSON.stringify(response)
      };
      
        this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
      }catch{}
  }

  async processDeinedCase(submitHistoryId, XAId, decisionAppId){
    try{
      var checkFraudRes = true;
      //Save Product code
      await this.loanApiLogService.saveProductCode(XAId, this.selectedProducts).toPromise();
      /// CHECK FRAUD AFTER SUBMIT
      checkFraudRes =  await this.nmaoWfService.checkFraudOrDup(XAId, this.selectedFundingType);
      if(!checkFraudRes){
        return checkFraudRes;
      }
      var appStatus = await this.nmaoWfService.addApprovedAccount_setAppStatus(XAId, XPRESS_LOAN_INFOStatus.DECLINED, this.selectedFundingType,this.xpressLoan.FUNDING_SOURCES, this.interestedAccounts, submitHistoryId).toPromise()
      var statusFragment = await this.nmaoWfService.setAppStatusFragment(XAId, APP_STATUSValue.DECLINED, submitHistoryId).toPromise();
      await this.saveSubmitFundingLog({checkFraudRes: checkFraudRes, appStatus : appStatus, statusFragment : statusFragment, 
        alloy_journeyApplicationStatus: this.submitHistory.alloy_journeyApplicationStatus,
        alloy_status: this.submitHistory.alloy_status, 
        alloy_completeOutcome: this.submitHistory.alloy_completeOutcome, 
        memberNumber: null})
      this.nmaoWfService.displayFinalPage(FinalPageEnum.ErrorReceived);
    }catch(ex){
      this.nmaoWfService.displayFinalPage(FinalPageEnum.ErrorReceived);
    }
  }

  async proccessApprovedCase(submitHistoryId, XAId, decisionAppId){
        await this.startNmaoWf(XAId, decisionAppId, submitHistoryId);     
  }

  async proccessWaitingReviewCase(submitHistoryId,  XAId, decisionAppId){
    try{
      var checkFraudRes = true;
      //Save Product code
      await this.loanApiLogService.saveProductCode(XAId, this.selectedProducts).toPromise();
      /// CHECK FRAUD AFTER SUBMIT
      checkFraudRes =  await this.nmaoWfService.checkFraudOrDup(XAId, this.selectedFundingType);
      if(!checkFraudRes){
        return checkFraudRes;
      }
     var appStatus= await this.nmaoWfService.addApprovedAccount_setAppStatus(XAId, XPRESS_LOAN_INFOStatus.REFERRED, this.selectedFundingType, this.xpressLoan.FUNDING_SOURCES, this.interestedAccounts,submitHistoryId).toPromise()
     await this.saveSubmitFundingLog({checkFraudRes: checkFraudRes, appStatus : appStatus, statusFragment : null, 
      alloy_journeyApplicationStatus: this.submitHistory.alloy_journeyApplicationStatus,
      alloy_status: this.submitHistory.alloy_status,
       alloy_completeOutcome: this.submitHistory.alloy_completeOutcome, 
       memberNumber: null})
     this.nmaoWfService.displayFinalPage(FinalPageEnum.Wait2Days)

    }catch(ex){
      this.nmaoWfService.displayFinalPage(FinalPageEnum.ErrorReceived)
    }
  }

  private async startNmaoWf(XAId: any, decisionAppId: any, submitHistoryId) {
    try{
      var checkFraudRes = true;

    //Save Product code
    await this.loanApiLogService.saveProductCode(XAId, this.selectedProducts).toPromise();
    /// CHECK FRAUD AFTER SUBMIT
    checkFraudRes = await this.nmaoWfService.checkFraudOrDup(XAId, this.selectedFundingType);
    if (!checkFraudRes) {
      return checkFraudRes;
    }

    //addApprovedAccount_setAppStatus
    var addApprovedAccount_setAppStatusResult = await this.nmaoWfService.addApprovedAccount_setAppStatus(XAId, XPRESS_LOAN_INFOStatus.PENDING, this.selectedFundingType, this.xpressLoan.FUNDING_SOURCES, this.interestedAccounts, submitHistoryId).toPromise()

    //fund deposit
    //? with funding page only
    var fundingCallResult = await this.nmaoWfService.fundingCall(this.buildFundingRequest(XAId), submitHistoryId);
    //If funding was bank account, then check for funding status as "PROCESSING"
    //IF funding was credit card, then check for funding status as "Funded"

    checkFraudRes = await this.nmaoWfService.checkFraudOrDup(XAId, this.selectedFundingType);
    if (!checkFraudRes) {
      return checkFraudRes;
    }

    if (fundingCallResult && this.nmaoWfService.fundingCallResult_check(XAId, this.selectedFundingType)) {

      var statusFragment = await this.nmaoWfService.setAppStatusFragment(XAId, APP_STATUSValue.INSTANTAPPROVED, submitHistoryId).toPromise()

      //simytar
      var symitarBookResult = await this.nmaoWfService.symitarBook(XAId, this.soResponses, submitHistoryId);
      var memberNumber = this.nmaoWfService.symitarBookResult_check(symitarBookResult)
      if (memberNumber) {
        try {
          await this.saveSubmitFundingLog({
            checkFraudRes: checkFraudRes,
            appStatus: addApprovedAccount_setAppStatusResult,
            statusFragment: statusFragment,
            alloy_journeyApplicationStatus: this.submitHistory.alloy_journeyApplicationStatus,
            alloy_status: this.submitHistory.alloy_status,
             alloy_completeOutcome: this.submitHistory.alloy_completeOutcome,
            memberNumber: memberNumber,
            fundingCallResult: fundingCallResult
          })
        } catch { }
        await this.nmaoWfService.presentAtomic(XAId, submitHistoryId);
        await this.nmaoWfService.openDocuSign(XAId, null, this.selectedProducts)
        FinalPageComponent.dataFinal.memberNumber = memberNumber;
        FinalPageComponent.dataFinal.firstName = this.xpressLoan.APPLICANTS[0].first_name;

        //get final status of alloy
        this.nmaoWfService.displayFinalPage(FinalPageEnum.Congratulation)
        return;
      }
    }


    var checkFraudRes = await this.nmaoWfService.checkFraudOrDup(XAId, this.selectedFundingType);
    if (!checkFraudRes) {
      return checkFraudRes;
    }

    //add approved-accounts and set status to REFERRED
    if (this.nmaoWfService.didAddApprovedAccounts) {
      statusFragment = await this.nmaoWfService.setAppStatusFragment(XAId, APP_STATUSValue.REFERRED, submitHistoryId).toPromise()
    } else {
      addApprovedAccount_setAppStatusResult = await this.nmaoWfService.addApprovedAccount_setAppStatus(XAId, XPRESS_LOAN_INFOStatus.REFERRED, this.selectedFundingType, this.xpressLoan.FUNDING_SOURCES, this.interestedAccounts, submitHistoryId).toPromise()
    }
    try {
      await this.saveSubmitFundingLog({
        checkFraudRes: checkFraudRes,
        appStatus: addApprovedAccount_setAppStatusResult,
        statusFragment: statusFragment,
        alloy_journeyApplicationStatus: this.submitHistory.alloy_journeyApplicationStatus,
      alloy_status: this.submitHistory.alloy_status, 
      alloy_completeOutcome: this.submitHistory.alloy_completeOutcome,
        memberNumber: memberNumber,
        fundingCallResult: fundingCallResult
      })
    } catch { }
    this.nmaoWfService.displayFinalPage(FinalPageEnum.Wait2Days);
    // (window as any).dataLayer.push({
    //   event: 'deposit-product-completed',
    //   gtm_elementClasses: 'funding-submit',
    //   value:  'Deposit app completed'
    // });
    }catch(ex){
      this.nmaoWfService.displayFinalPage(FinalPageEnum.ErrorReceived);
    }
  }

 

  buildFundingRequest(loanId){


  var requestJson = JSON.stringify((!!this.cardDetails?.cardNumber ? [{last4:this.cardDetails?.cardNumber?.slice(-4), cvn:this.cardDetails?.ccv}] : []));

   var requestJsonCCsEncrypted=  this.nmaoWfService.encryptRsa(requestJson);

    var request = {
      loanId: loanId,
      requestJsonCCsEncrypted:  requestJsonCCsEncrypted
    }as any;
    return request;

  }

  async openPlaidForm(index, fundingMethod) {
    this.showPlaidError = false;
  
    try {
      const response = await this.plaidService.link();
  
      if (response?.error?.error_message) {
        this.showPlaidError = true;
        return;
      }
      
      try { this.saveMiscEvent('FundingSourceFormAction', 'Closed plaid form.'); } catch {}
  
      this.selectedFundingType = XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK;
      this.isCash = false;
      this.bankDetails = {} as any;
      this.cardDetails = {} as any;
      const account = response.accounts[0];
      const achNumbers = response.numbers.ach[0];
  
      this.bankDetails.bank_name_on_card = this.creditCardLoan.APPLICANTS.APPLICANT[0].first_name + " " + this.creditCardLoan.APPLICANTS.APPLICANT[0].last_name;
  
      this.bankDetails.routing_number = achNumbers.routing;
      this.bankDetails.bank_account_number = achNumbers.account;
      this.bankDetails.bank_account_type =
        XPRESS_FUNDING_SOURCESFUNDING_SOURCEBank_account_type[account.subtype.toUpperCase() as keyof typeof XPRESS_FUNDING_SOURCESFUNDING_SOURCEBank_account_type];
  
      const fundingBank = _.find(this.fundingSources, { funding_Type: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK });
  
      if (!this.xpressLoan.FUNDING_SOURCES) this.xpressLoan.FUNDING_SOURCES = [];
  
      this.invalidRoutingNumnerMsg = "";
  
      if (!/^\d{9}$/.test(this.bankDetails.routing_number)) {
        this.invalidRoutingNumnerMsg = "Routing number must be exactly 9 digits.";
        this.showPlaidError = true;
        return;
      }

      var bankNameFailed = localStorage.getItem("bankNameFailed");
      var plaidBankName = response?.item?.institution_name;

      if(bankNameFailed && plaidBankName && bankNameFailed == plaidBankName){
        this.showPlaidError = true;
        return;
      }

      try {
        const bankInfo = await this.apiService.getBank(this.bankDetails.routing_number).toPromise();
        if (bankInfo && !bankInfo.error && bankInfo.bankName && bankInfo.bankState) {

          // if(bankNameFailed && bankNameFailed.toLowerCase() == bankInfo.bankName.toLowerCase())
          this.bankDetails.bank_bankname = bankInfo.bankName;
          this.bankDetails.bank_bankstate = bankInfo.bankState;
  
          const f_source = { ...this.bankDetails };
          f_source.clf_funding_source_id = fundingBank?.clF_Funding_Source_Id;
          f_source.funding_type = fundingBank?.funding_Type;
  
          this.xpressLoan.FUNDING_SOURCES.push(f_source);
  
          this.setActiveFundingSource(index);
          this.isSelectedMethod = true;
          this.selectedFundingSource = fundingMethod;
  
          this.checkFormValid();
  
          try { this.saveMiscEvent('FundingSourceAdd-Remove', `Added bank by plaid.`, response.access_token); } catch {}
        }
      } catch {
        this.showPlaidError = true;
      }
  
    } catch (err) {
      this.showPlaidError = true;
      if (err?.isExit) {
        try { this.saveMiscEvent('FundingSourceFormAction', 'Closed plaid form.'); } catch {}
      }
    }
  }
  



  onChangeAmountDeposit(){
    const totalAmount = this.interestedAccounts.reduce((sum, account) => {
      return sum + (account.amount_deposit || 0);
    }, 0);
    this.totalDeposit =  totalAmount;

    // Calculate savings products total
    const savingsProducts = this.getCertProdsOnly(true);
    this.savingsTotalDeposit = savingsProducts.reduce((sum, account) => {
      return sum + (account.amount_deposit || 0);
    }, 0);

    // Calculate certificate products total
    const certificateProducts = this.getCertProdsOnly(false);
    this.certificateTotalDeposit = certificateProducts.reduce((sum, account) => {
      return sum + (account.amount_deposit || 0);
    }, 0);

    this.checkFormValid()

  }

  openConfirmRemoveFundingSource(){
    this.dialog.open(ConfirmationDialog, {
      panelClass: AppComponent.isDesktop ? 'col-md-4' : 'full-screen',
      scrollStrategy:  AppComponent.scrollStrategy,
      data:{
        confirmMessage: 'Are you sure you would like to remove funding information?',
      },
      autoFocus: true,
      disableClose: true
    }).afterClosed().subscribe(r=>{
      if(r){
        this.removeFundingSourceSelected();
      }
      this.checkFormValid();
    })
  }
  removeFundingSourceSelected() {
    
    const index = _.findIndex(this.xpressLoan.FUNDING_SOURCES,(item: any) => item.funding_Type === this.selectedFundingSource.funding_Type);
    if (index != -1) {
      this.xpressLoan.FUNDING_SOURCES.splice(index, 1);
    }
    switch(this.selectedFundingSource.funding_Type){
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK:
       if(this.bankDetails && this.bankDetails.bank_account_number){
        _.remove(this.xpressLoan.FUNDING_SOURCES, { bank_account_number: this.bankDetails?.bank_account_number })
       }
        this.bankDetails = {} as any;
        try{
          if(this.selectedFundingSource.displayName && this.selectedFundingSource.displayName.toLowerCase().includes('plaid')){
            this.saveMiscEvent('FundingSourceAdd-Remove', `Removed plaid.`);
          }else{
            this.saveMiscEvent('FundingSourceAdd-Remove', `Removed bank.`);
          }
        }catch{}
        break;
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CREDITCARD:
        if(this.cardDetails && this.cardDetails.cardNumber){
          _.remove(this.xpressLoan.FUNDING_SOURCES, { cc_card_number: this.cardDetails.cardNumber })
         }
          this.cardDetails = {} as any;
          try{
            this.saveMiscEvent('FundingSourceAdd-Remove', `Removed credit card.`);
          }catch{}
        break;
      case XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.CASH:
        break; 
      default:
        break; 
    }
    this.isSelectedMethod = false;
    this.selectedFundingSource = {} as any;
    _.each(this.fundingSources, item =>{
      item.isSelected = false;
    })
  }
  
  resolvedCaptchaToken(captchaToken: string){
    this.captchaToken = captchaToken;
  }

  //google tag manager
  unfocusTotalDeposit(value){
    if(!value){
      // (window as any).dataLayer.push({
      //   event: 'unfocus-total-deposit',
      //   gtm_elementClasses: 'total-deposit',
      //   value: `User didn't list "How much to deposit"  `
      // });   
    }
  }

  
  checkFundingSource(){
    // (window as any).dataLayer.push({
    //   event: 'unConfirm-funding-source',
    //   gtm_elementClasses: 'funding-submit',
    //   value:  `User haven’t selected the “Funding Source.”`
    // });
  }

  getFundingSources(baseType, channelUri){
    this.apiService.getFundingSourcesNew(baseType, channelUri).subscribe(res => {
      if(res){
        _.each(res, item => {
          item.isSelected = false;
          //item.maxDeposit should follow:
          // If Credit/Debit (funding_Type 1) then maximum is 500
          // if ACH or Plaid ((funding_Type 2) then
          // total of certificate can’t be more than 250k
          // Total of other accounts such as savings, quick pay, money market can’t be more than 12K
          if(item.funding_Type == 2){
            item.maxDeposit = 12000;
            if(this.selectedProducts.find(a=>a.productGroupId ==3) != null){ // cert prod
              item.maxDeposit +=250000;
            }
            
          }
          if (item.helperText && item.maxDeposit && item.maxDeposit >0) {
            const formattedDeposit = parseFloat(item.maxDeposit).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            item.helperText = item.helperText.replace(/\$\d+(?:,\d{3})*(?:\.\d{1,2})?/g, `$${formattedDeposit}`);
          }
      });
        // Plaid funding is sunset (hidden) - filter it out of the selectable funding methods.
        // See plaid-sunset-notes.md for the full removal plan.
        this.fundingSources = res.filter(item => !(item.displayName && item.displayName.toLowerCase().includes('plaid')));
      }
    })
  } 
  
  getHelperTextFromConfig(){
    this.apiService.getProductTypeConfig().subscribe(config => {
      this.helperTextFundingPage = config["helperTextFundingPage"]
    })
  } 



  last4AccountNumber(accountNumber: number | string): string {
    if (!accountNumber || accountNumber.toString().trim() === '') {
        return '';
    }
    const accountStr = accountNumber.toString();  
    if (accountStr.length < 4) {
        return accountStr;
    } 
    const last4Digits = accountStr.slice(-4);
    const maskedPart = 'x';    
    return maskedPart + last4Digits;
  }

  expirationDateCreditCard(month: any = '', year: any = ''){
    const formattedYear = year.toString().slice(-2);
    return `${month}/${formattedYear}`;
  }

  saveMiscEvent(eventName : string, eventDetail: string, itemId?: string ){
    var payload ={
      submitHistoryId : this.submitHistory.id,
      eventName : eventName,
      eventDetail : eventDetail,
      itemId: itemId
    }
    this.apiService.saveMiscEvent(payload).subscribe({    
      complete: () => {},
      error: () => {}
    });
  }

  retryPlaid() {
    this.showPlaidError = false;
    // Find the Plaid funding source and retry
    const plaidFundingSource = this.fundingSources.find(source => 
      source.displayName && source.displayName.toLowerCase().includes('plaid')
    );
    if (plaidFundingSource) {
      const index = this.fundingSources.indexOf(plaidFundingSource);
      this.openPlaidForm(index, plaidFundingSource);
    }
  }

  openBankFormDialog() {
    this.showPlaidError = false;
    // Find the bank transfer funding source and open manual form
    const bankFundingSource = this.fundingSources.find(source => 
      source.funding_Type === XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type.BANK && 
      !(source.displayName && source.displayName.toLowerCase().includes('plaid'))
    );
    if (bankFundingSource) {
      const index = this.fundingSources.indexOf(bankFundingSource);
      this.openBankForm(index, bankFundingSource);
    }
  }

}
